import { c as _c } from "react/compiler-runtime";
import { PathType, type InventoryResource } from '@repo/api-gw-sdk';
import { Base64 } from 'js-base64';
import { CopyToClipboardWrapper } from '@/components/buttons/copyToClipboardButton';
import { useRoles } from '@/contexts/useRoles';
import { TextLink } from '../shared/textLink';
import { AuthorizationTooltip } from '../tooltips/authorizationTooltip';
function trimLocation(location: string): string {
  // Trims the location to 45 characters, puts ellipsis in the middle
  if (location.length <= 45) {
    return location;
  }
  return `${location.slice(0, 20)}...${location.slice(-25)}`;
}
export const PathLink = t0 => {
  const $ = _c(5);
  const {
    entity,
    path,
    pathType,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== entity || $[2] !== path || $[3] !== pathType) {
    t1 = pathType === PathType.File ? <FileLink entity={entity} location={path} isWindowsMachine={isWindowsMachine([path])} className={className} /> : <DirLink entity={entity} location={path} className={className} />;
    $[0] = className;
    $[1] = entity;
    $[2] = path;
    $[3] = pathType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export function FileLink(t0) {
  const $ = _c(15);
  let {
    entity,
    location,
    isWindowsMachine,
    className,
    copyToClipboard: t1
  } = t0;
  const copyToClipboard = t1 === undefined ? true : t1;
  if (isWindowsMachine) {
    if (location.startsWith("/")) {
      let t2;
      if ($[0] !== location) {
        t2 = location.substring(1);
        $[0] = location;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      location = t2;
    }
    let t2;
    if ($[2] !== location) {
      let t3;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /\//g;
        $[4] = t3;
      } else {
        t3 = $[4];
      }
      t2 = location.replace(t3, "\\");
      $[2] = location;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    location = t2;
  }
  const t2 = copyToClipboard ? location : "";
  const t3 = entity;
  const t4 = location;
  const t5 = encodeURIComponent(entity.id);
  let t6;
  if ($[5] !== location) {
    t6 = Base64.encode(location);
    $[5] = location;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `/explorer/${t5}?file=${t6}`;
  let t8;
  if ($[7] !== className || $[8] !== entity || $[9] !== location || $[10] !== t7) {
    t8 = <BasicLink entity={t3} label={t4} href={t7} className={className} />;
    $[7] = className;
    $[8] = entity;
    $[9] = location;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t8) {
    t9 = <CopyToClipboardWrapper textToCopy={t2}>{t8}</CopyToClipboardWrapper>;
    $[12] = t2;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}
function DirLink(t0) {
  const $ = _c(7);
  const {
    entity,
    location,
    className
  } = t0;
  const t1 = encodeURIComponent(entity.id);
  let t2;
  if ($[0] !== location) {
    t2 = Base64.encode(location);
    $[0] = location;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const href = `/explorer/${t1}?dir=${t2}`;
  let t3;
  if ($[2] !== className || $[3] !== entity || $[4] !== href || $[5] !== location) {
    t3 = <BasicLink entity={entity} label={location} href={href} className={className} />;
    $[2] = className;
    $[3] = entity;
    $[4] = href;
    $[5] = location;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export const BasicLink = t0 => {
  const $ = _c(16);
  const {
    entity,
    label,
    href,
    className
  } = t0;
  const {
    isAuthorizedResource
  } = useRoles();
  let t1;
  if ($[0] !== entity || $[1] !== isAuthorizedResource) {
    t1 = isAuthorizedResource("read:files", entity);
    $[0] = entity;
    $[1] = isAuthorizedResource;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isAuthorized = t1;
  let t2;
  if ($[3] !== entity || $[4] !== isAuthorizedResource) {
    t2 = isAuthorizedResource("read:files", entity);
    $[3] = entity;
    $[4] = isAuthorizedResource;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = !t2;
  let t4;
  if ($[6] !== label) {
    t4 = trimLocation(label) ?? "Unknown";
    $[6] = label;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className || $[9] !== href || $[10] !== t3 || $[11] !== t4) {
    t5 = <span><TextLink href={href} data-testid="file-explorer-link" disabled={t3} className={className}>{t4}</TextLink></span>;
    $[8] = className;
    $[9] = href;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== isAuthorized || $[14] !== t5) {
    t6 = <AuthorizationTooltip isAuthorized={isAuthorized}>{t5}</AuthorizationTooltip>;
    $[13] = isAuthorized;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export const isWindowsMachine = (examples: string[]) => examples.filter(Boolean).some(example => ['/C:/', '/D:/', '/E:/', '/F:/', 'C:/', 'D:/', 'E:/', 'F:/', 'C:\\', 'D:\\', 'E:\\', 'F:\\'].some(prefix => example.toUpperCase()?.startsWith(prefix)));